import { Link, useNavigate } from "@tanstack/react-router";
import { FormularioCotizacion } from "../componentes/formulario-cotizacion";
import { useCrearCotizacion } from "../lib/cotizaciones";

export function CotizacionNueva() {
  const navegar = useNavigate();
  const crear = useCrearCotizacion();

  return (
    <div className="space-y-4">
      <Link to="/cotizaciones" className="text-sm text-marca-600 hover:underline">
        ← Cotizaciones
      </Link>
      <h1 className="text-lg font-semibold">Nueva cotización</h1>

      <div className="rounded-lg border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
        <FormularioCotizacion
          enviando={crear.isPending}
          errorServidor={crear.error ? crear.error.message : null}
          alEnviar={(datos) =>
            crear.mutate(datos as never, {
              onSuccess: (c) =>
                void navegar({ to: "/cotizaciones/$id", params: { id: c.id } }),
            })
          }
          alCancelar={() => void navegar({ to: "/cotizaciones" })}
        />
      </div>
    </div>
  );
}
